<p-message *ngIf="loginErrorMessage" severity="error" [text]="loginErrorMessage" styleClass="block my-3"></p-message>

<div *ngIf="loginErrorMessage" class="text-red-500 text-center mt-3">
  {{ loginErrorMessage }}
</div>
